import React from 'react';
import Header from '../../Shared/Header';
import BreadCums from '../../Shared/BreadCums';
import TermsDetails from './TermsDetails';
import Footer3 from '../../Shared/Footer3';

const Terms = () => {
    return (
        <>
            <Header
                parentMenu='pages'
                headerClass='sc-header-section inner-header-style'
                signUpBtn='inner-btn'
            />
            <BreadCums pageTitle='Terms & Conditions' />
            <TermsDetails />
            <Footer3 />
        </>
    );
};

export default Terms;
